import { searchMembersQuery } from "@/api/member";
import { queryClient } from "@/api/utils";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/members/$memberId")({
  beforeLoad: () => ({
    breadcrumb: "View Member",
  }),
  component: lazyRouteComponent(() => import("./+Member")),
  head: async ({ params }) => {
    const members = await queryClient.ensureQueryData(searchMembersQuery(params.memberId));
    const member = members?.members.find(m => m.member_id === params.memberId);
    return { meta: seo({ title: member ? member?.given_name + " " + member?.family_name : "View Member" }) };
  },
});
